import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PageNavigation from "@/components/PageNavigation";
import SEOHead from "@/components/seo/SEOHead";

export default function TermosUso() {
  return (
    <>
      <SEOHead
        title="Termos de Uso"
        description="Termos de Uso da plataforma Vendas Trainer. Conheça suas responsabilidades e direitos como usuário do nosso treinador de vendas com IA."
        keywords="termos de uso, contrato, regras, política, condições de uso"
        canonicalUrl="https://bianchimbusiness.com.br/termos-uso"
      />

      <Header />

      <main id="main-content" className="min-h-screen bg-background pt-20" role="main" aria-labelledby="page-title">
        <article className="container mx-auto px-4 py-16 max-w-4xl">
          <header>
            <h1 id="page-title" className="text-4xl font-bold text-foreground mb-8">Termos de Uso</h1>
          </header>
          
          <div className="prose prose-lg dark:prose-invert max-w-none space-y-6 text-muted-foreground">
            <p className="text-lg"><strong>Última atualização:</strong> Janeiro de 2026</p>

            <section className="space-y-4" aria-labelledby="accept-section">
              <h2 id="accept-section" className="text-2xl font-semibold text-foreground">1. Aceitação dos Termos</h2>
              <p>Ao acessar e usar o Vendas Trainer, você concorda com estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não deve usar nosso serviço.</p>
            </section>

            <section className="space-y-4" aria-labelledby="desc-section">
              <h2 id="desc-section" className="text-2xl font-semibold text-foreground">2. Descrição do Serviço</h2>
              <p>O Vendas Trainer é uma plataforma de treinamento de vendas que utiliza inteligência artificial para simular conversas de vendas, proporcionando um ambiente de prática seguro para desenvolvimento de habilidades comerciais.</p>
            </section>

            <section className="space-y-4" aria-labelledby="account-section">
              <h2 id="account-section" className="text-2xl font-semibold text-foreground">3. Cadastro e Conta</h2>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li>Você deve fornecer informações verdadeiras e atualizadas</li>
                <li>É responsável por manter a confidencialidade de sua senha</li>
                <li>Deve notificar imediatamente sobre uso não autorizado</li>
                <li>Menores de 18 anos precisam de autorização dos responsáveis</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="use-section">
              <h2 id="use-section" className="text-2xl font-semibold text-foreground">4. Uso Aceitável</h2>
              <p>Você concorda em não:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li>Violar leis ou regulamentos aplicáveis</li>
                <li>Compartilhar credenciais de acesso</li>
                <li>Tentar acessar áreas restritas do sistema</li>
                <li>Usar o serviço para fins ilegais ou não autorizados</li>
                <li>Interferir no funcionamento da plataforma</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="ip-section">
              <h2 id="ip-section" className="text-2xl font-semibold text-foreground">5. Propriedade Intelectual</h2>
              <p>Todo o conteúdo da plataforma, incluindo textos, gráficos, logos, ícones, imagens e software, é propriedade da Bianchim Business ou de seus licenciadores e está protegido por leis de direitos autorais.</p>
            </section>

            <section className="space-y-4" aria-labelledby="payment-section">
              <h2 id="payment-section" className="text-2xl font-semibold text-foreground">6. Planos e Pagamentos</h2>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li>Os preços estão sujeitos a alterações com aviso prévio</li>
                <li>Renovações são automáticas, salvo cancelamento</li>
                <li>Limites de uso variam conforme o plano contratado</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="refund-section">
              <h2 id="refund-section" className="text-2xl font-semibold text-foreground">7. Reembolso e Cancelamento</h2>

              <h3 className="text-xl font-semibold text-foreground pt-2">7.1. Direito de arrependimento (7 dias)</h3>
              <p>
                Conforme o <strong>art. 49 do Código de Defesa do Consumidor</strong>, você pode desistir da compra
                online em até <strong>7 dias corridos</strong> contados da contratação, com devolução integral dos valores
                pagos. No Vendas Trainer, o reembolso é <strong>automático</strong> e feito por você, sem necessidade de
                contato prévio.
              </p>

              <h3 className="text-xl font-semibold text-foreground pt-2">7.2. Condições e prazos por caso</h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-border rounded-lg">
                  <thead className="bg-primary/10 text-foreground">
                    <tr>
                      <th className="text-left p-3 border-b border-border">Situação</th>
                      <th className="text-left p-3 border-b border-border">Prazo</th>
                      <th className="text-left p-3 border-b border-border">Resultado</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    <tr>
                      <td className="p-3">Compra há menos de 7 dias e até 10 feedbacks usados</td>
                      <td className="p-3">Até 7 dias corridos</td>
                      <td className="p-3">✅ Reembolso integral automático</td>
                    </tr>
                    <tr>
                      <td className="p-3">Compra há mais de 7 dias</td>
                      <td className="p-3">Prazo excedido</td>
                      <td className="p-3">❌ Sem reembolso (art. 49 não se aplica)</td>
                    </tr>
                    <tr>
                      <td className="p-3">Menos de 7 dias, porém mais de 10 feedbacks usados</td>
                      <td className="p-3">Dentro de 7 dias</td>
                      <td className="p-3">❌ Sem reembolso (saldo bônus já consumido)</td>
                    </tr>
                    <tr>
                      <td className="p-3">Cancelamento de plano mensal</td>
                      <td className="p-3">A qualquer momento</td>
                      <td className="p-3">🔄 Sem cobrança no mês seguinte</td>
                    </tr>
                    <tr>
                      <td className="p-3">Cancelamento de plano anual</td>
                      <td className="p-3">A qualquer momento</td>
                      <td className="p-3">💸 Estorno proporcional dos meses não usados</td>
                    </tr>
                    <tr>
                      <td className="p-3">Plano ativado por voucher (presente gratuito)</td>
                      <td className="p-3">Cancelamento automático</td>
                      <td className="p-3">↩️ Volta ao plano Start, sem valor a reembolsar</td>
                    </tr>
                    <tr>
                      <td className="p-3">Plano ativado por voucher (pago presencial/direto)</td>
                      <td className="p-3">Cancelamento automático</td>
                      <td className="p-3">⚠️ Tratar reembolso com o fornecedor</td>
                    </tr>
                    <tr>
                      <td className="p-3">Cobrança indevida ou plataforma indisponível 72h+</td>
                      <td className="p-3">Sem prazo limite</td>
                      <td className="p-3">✅ Reembolso mediante análise</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="text-xl font-semibold text-foreground pt-2">7.3. Como solicitar</h3>
              <ol className="list-decimal pl-6 space-y-2" role="list">
                <li>Acesse o painel do coordenador e localize o cartão “Plano”</li>
                <li>Se elegível, o botão <strong>“Pedir reembolso”</strong> aparece ativo; caso contrário, o painel exibe o motivo (prazo de 7 dias excedido ou mais de 10 feedbacks consumidos)</li>
                <li>Confirme o alerta — a ação é <strong>irreversível</strong>, a assinatura é encerrada e a conta volta ao plano Start</li>
                <li>O estorno é processado pela Stripe em até <strong>10 dias úteis</strong></li>
                <li>Para cancelar (sem reembolso), clique em <strong>“Cancelar plano”</strong>; no mensal vale a partir do mês seguinte, no anual há estorno proporcional automático</li>
              </ol>

              <h3 className="text-xl font-semibold text-foreground pt-2">7.4. Forma de estorno</h3>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li><strong>Cartão:</strong> crédito na próxima fatura ou fatura futura (até 2 ciclos)</li>
                <li><strong>PIX:</strong> transferência para a chave usada no pagamento original</li>
                <li><strong>Boleto:</strong> transferência bancária para conta indicada pelo cliente</li>
              </ul>

              <p>
                Para detalhes completos, consulte a{" "}
                <a href="/politica-reembolso" className="text-primary hover:underline">
                  Política de Reembolso
                </a>
                .
              </p>
            </section>

            <section className="space-y-4" aria-labelledby="liability-section">
              <h2 id="liability-section" className="text-2xl font-semibold text-foreground">8. Limitação de Responsabilidade</h2>
              <p>O Vendas Trainer é fornecido "como está". Não garantimos resultados específicos de vendas ou que o serviço será ininterrupto. Nossa responsabilidade é limitada ao valor pago pelo serviço nos últimos 12 meses.</p>
            </section>

            <section className="space-y-4" aria-labelledby="termination-section">
              <h2 id="termination-section" className="text-2xl font-semibold text-foreground">9. Rescisão</h2>
              <p>Podemos suspender ou encerrar seu acesso por violação destes termos. Você pode cancelar sua conta a qualquer momento através das configurações da plataforma.</p>
            </section>

            <section className="space-y-4" aria-labelledby="changes-section">
              <h2 id="changes-section" className="text-2xl font-semibold text-foreground">10. Alterações nos Termos</h2>
              <p>Reservamo-nos o direito de modificar estes termos. Alterações significativas serão comunicadas por e-mail ou através da plataforma.</p>
            </section>

            <section className="space-y-4" aria-labelledby="contact-section">
              <h2 id="contact-section" className="text-2xl font-semibold text-foreground">11. Contato</h2>
              <p>Para dúvidas sobre estes termos:</p>
              <address className="not-italic space-y-2">
                <p><strong>E-mail:</strong> <a href="mailto:junior@bianchimbusiness.com.br" className="text-primary hover:underline">junior@bianchimbusiness.com.br</a></p>
                <p><strong>Telefone:</strong> <a href="tel:+5516981960018" className="text-primary hover:underline">+55 (16) 98196-0018</a></p>
                <p><strong>Endereço:</strong> Rua Danilo Micalli, 50 - Santa Felícia, São Carlos – SP – CEP: 13563-264</p>
              </address>
            </section>
          </div>
        </article>
      </main>

      <PageNavigation />
      <Footer />
    </>
  );
}
